import React from "react";
import { TiFlashOutline } from "react-icons/ti";

const AnimatedCirclesComponent = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Red Box */}
      <div
        style={{
          borderRadius: "8px",
          zIndex: 10,
          position: "relative",
        }}
      >
        <TiFlashOutline color="#3BA44A" size={"70px"} />
      </div>

      {/* Circle 0 - New Innermost */}
      <div
        style={{
          position: "absolute",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          border: "8px solid rgba(0, 163, 84, 0.9)",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          animation: "pulse0 4.5s ease-in-out infinite",
          zIndex: 0,
        }}
      ></div>

      {/* Circle 1 - Now second innermost */}
      <div
        style={{
          position: "absolute",
          width: "160px",
          height: "160px",
          borderRadius: "50%",
          border: "7px solid rgba(0, 163, 84, 0.7)",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          animation: "pulse1 4.5s ease-in-out infinite",
          zIndex: 1,
        }}
      ></div>

      {/* Circle 2 - Middle */}
      <div
        style={{
          position: "absolute",
          width: "220px",
          height: "220px",
          borderRadius: "50%",
          border: "6px solid rgba(0, 163, 84, 0.4)",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          animation: "pulse2 4.5s ease-in-out infinite",
          animationDelay: "0s",
          zIndex: 2,
        }}
      ></div>

      {/* Circle 3 - Outermost */}
      <div
        style={{
          position: "absolute",
          width: "280px",
          height: "280px",
          borderRadius: "50%",
          border: "5px solid #00a354",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          animation: "pulse3 4.5s ease-in-out infinite",
          animationDelay: "0s",
          zIndex: 3,
        }}
      ></div>

      <style jsx>{`
        @keyframes pulse0 {
          0% {
            width: 100px;
            height: 100px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.9);
          }
          50% {
            width: 120px;
            height: 120px;
            opacity: 0.5;
            border-color: rgba(0, 163, 84, 1);
          }
          100% {
            width: 100px;
            height: 100px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.9);
          }
        }

        @keyframes pulse1 {
          0% {
            width: 160px;
            height: 160px;
            opacity: 1;
            border-color: #00a354;
          }
          50% {
            width: 200px;
            height: 200px;
            opacity: 0.3;
            border-color: rgba(0, 163, 84, 1);
          }
          100% {
            width: 160px;
            height: 160px;
            opacity: 1;
            border-color: #00a354;
          }
        }

        @keyframes pulse2 {
          0% {
            width: 220px;
            height: 220px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.7);
          }
          50% {
            width: 260px;
            height: 260px;
            opacity: 0.2;
            border-color: rgba(0, 163, 84, 1);
          }
          100% {
            width: 220px;
            height: 220px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.7);
          }
        }

        @keyframes pulse3 {
          0% {
            width: 280px;
            height: 280px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.5);
          }
          50% {
            width: 320px;
            height: 320px;
            opacity: 0.5;
            border-color: rgba(0, 163, 84, 0.3);
          }
          100% {
            width: 280px;
            height: 280px;
            opacity: 1;
            border-color: rgba(0, 163, 84, 0.5);
          }
        }
      `}</style>
    </div>
  );
};

export default AnimatedCirclesComponent;
